// Image imports
import masterSgtOriDaninoPortrait from '../../../images/ori-danino.webp';

export const masterSgtOriDaninoMemorial = {
  id: 17,
  name: 'Master Sgt. Ori Danino',
  category: 'community-leaders',
  images: {
    portrait: masterSgtOriDaninoPortrait
  },
  info: `

"Ori was known for his ambition, love for people, and was beloved by all. He loved nature and was very handy." - Hostages and Missing Families Forum

# Master Sgt. Ori Danino

![Master Sgt. Ori Danino](${masterSgtOriDaninoPortrait})
*Master Sgt. Ori Danino, whose sense of duty led him back into danger*

## A Life of Promise

Ori Danino was just 25 years old, from Jerusalem and the eldest of five siblings. He was engaged to his partner Liel, and together they were planning their future. Ori had dreams of studying electrical engineering after completing his military service - a dream he would never have the chance to fulfill.

Friends describe Ori as someone who lit up rooms with his smile and easygoing nature. He had a natural talent for fixing things, often helping family and friends with repairs and projects. His hands were capable and strong, reflecting his practical approach to life's challenges.

## The Call of Duty

On October 7th, 2023, Ori was off-duty but in the area of the Nova music festival when the Hamas attack began. Instead of fleeing to safety, witnesses report that he drove back toward the chaos, determined to help others escape. This selfless act of courage would lead to his capture by Hamas terrorists.

"That was Ori," his father said at his funeral. "Always thinking of others before himself. Always running toward those who needed help, not away from danger."

## A Family's Vigil

For 11 months, Ori's family waited and prayed for his return. His fiancée Liel kept their apartment exactly as Ori had left it, unable to change anything in his absence. His siblings spoke publicly at rallies, demanding action to bring him home along with all the other hostages.

His mother recounted how Ori would call her every Friday to wish her Shabbat Shalom, a tradition that began when he first entered military service. "For 11 months, every Friday, I waited by the phone that wouldn't ring," she said. "I kept his message on my voicemail just to hear his voice."

## A Final Tragedy

On August 31, 2024, Israeli forces recovered Ori's body along with five other hostages from a tunnel in Rafah. According to Israeli officials, all six had been executed by their captors shortly before they were found.

The military funeral for Master Sergeant Ori Danino was attended by hundreds, including his commanding officers who spoke of his dedication and bravery. His fiancée Liel placed his engagement ring on his coffin, a symbol of the future they would never share.

## A Legacy of Service

In Ori's memory, his family has established a scholarship fund for electrical engineering students from disadvantaged backgrounds, ensuring that although Ori cannot fulfill his own academic dreams, he can help others achieve theirs.

At the military cemetery in Jerusalem where he was laid to rest, Ori's grave is often adorned with tools left by friends and family - screwdrivers, wrenches, small hammers - symbols of the practical skills and helping hands that defined his all-too-brief life.

May his memory be a blessing, and may his courage inspire generations to come.

`
};